<template>
  <div class="page withdraw-preview">
    <!-- 导航条 -->
    <navigation type="second-level" :sticky="true" :showBack="false">完成确认，立即放款</navigation>
    <section class="header-tips">
      <img src="./image/header-tips.png" >
      <div class="info">
        <h3>待资方推送确认</h3>
        <p>确认以下提现要素，立即推送资方放款</p>
      </div>
   
    </section>

    <div class="pre-title">
      <h3>提现要素</h3>
    </div>
    <div class="pre-info">
      <div class="item">
        <p>提现金额/期数</p>
        <span>{{loanPrin|currency}}元/{{loanTerm}}期</span>
      </div>
      <div class="item">
        <p>综合年化利率/应还总息费</p>
        <span>{{intRate * 100| currency}}%/{{interestFee | currency}}元</span>
      </div>
    </div>
   
    <nd-cell class="info-line " :arrow="false" title="收款账户" :text="`${cardText}`" data-sensors-click></nd-cell>

    <!-- 大权益选择 -->
    <div  class="info-bvip"  :class="{shine: checkGreatVIP !== 'Y'}" >
      <div class="bvip-title">
        <div style="display: flex; align-items: center;" data-sensors-click @click="checkGreatVIP = checkGreatVIP === 'Y' ? 'N' : 'Y'">
          <img v-if="checkGreatVIP == 'Y'" src="./image/circle_02@2x.png" class="title-img">
          <img v-else src="./image/circle_02_no@2x.png" class="title-img">
          <span>{{loanProcessTitle}}</span>
          <img  src="./image/icon_info_w@2x.png" class="title-tips" @click.stop="bvipVisible = true">
        </div>
        <div class="title-info"  v-if="!isWHD">
          <span>{{greatVIPCoupon.termAmount | currency}}元/期</span>
          （共{{greatVIPCoupon.countTerm}}期）
        </div>
        <div
          class="bvip-mark"
          v-else
        >
          <span class="mark-item">99%用户选择</span>
          <span class="mark-item">最高价值{{ greatVIPCoupon.maxAmount}}元</span>
        </div>
      </div>
      <div class="bvip-info" v-if="!isWHD">
        <p>畅享专属特权大礼包，最高价值{{greatVIPCoupon.maxAmount}}元</p>
        <p class="bvip-user-choss">注：99%的用户选择了该权益</p>
      </div>

      <div v-else class="wh-title">
        <div class="title-info"><span class="color-primary">约{{ greatVIPCoupon.termAmount | currency }}元/期</span>（共{{ greatVIPCoupon.countTerm }}期）</div>
        <div class="bvip-user-choss">(以实际支付的金额为准)</div>
      </div>
    </div>

    <div class="repayment-schedule a">
      <div class="cell-title">
        还款计划<em>（还款实际到期日以实际放款时间为准）</em>
      </div>

      <div class="schedule-list">
        <table>
          <thead>
            <tr class="table-header">
              <th width="20%">期数</th>
              <th width="35%">到期日</th>
              <th width="30%">当期应还(元)</th>
            </tr>
          </thead>
          <tbody style="padding: 31px 0;">
            <tr class="table-row" v-for="(item, index) in termInfo" :key="index">
              <td>{{ item.termNo }}/{{ termInfo.length }}</td>
              <td>{{ item.paidOutDate | date('YYYY/MM/DD') }}</td>
              <td>{{ item.schdAmt | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="apply-time">
      <div class="label"><img src="./image/icon_success.png">平台审核通过</div>
      <span>{{ auditPassTime | formateTime }}</span> 
    </div>


    <!-- 立即提现区域 -->
    <section class="bottom">
      <div class="count-down-container" v-if="guideExpireTime">
        <div class="label">提现订单即将关闭，请立即确认</div>
        <van-count-down :time="guideExpireTime"  @finish="finish">
          <template #default="timeData">
            <span class="block">{{ timeFormat(timeData.hours) }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeFormat(timeData.minutes) }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeFormat(timeData.seconds) }}</span>
          </template>
        </van-count-down>
      </div>
      <nd-button class="withdraw-btn" @click="handlePreCheck" :disabled="style === 'A'" >立即确认提现</nd-button>
      <section class="read-protocol">
        <span>点击「立即确认提现」按钮，表示您已阅读并同意<em @click.stop="viewProtocol">《相关协议》</em></span>
      </section>
    </section>


    <bvip-tips-dialog v-model="bBvipTipsVisible" :loanProcessTitle="loanProcessTitle" @on-next="applyWithdraw"></bvip-tips-dialog>
    <bvip-action-sheet v-model="bvipActionSheetVisible" :isWHD="isWHD"   :loanProcessTitle="loanProcessTitle" :greatVIPCoupon="greatVIPCoupon" @on-protocol="viewProtocol" @on-withdraw="actionWithdraw"></bvip-action-sheet>

    <bvip-intro-dialog v-model="bvipVisible" :content="greatVIPCoupon.couponPopupDesc"></bvip-intro-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BvipIntroDialog from './components/bvip-intro-dialog.vue'
import withdrawConfig from '@/view/withdraw/assets/withdrawConfig.js'
export default {
  name: 'withdraw-preview-next',
  mixins: [withdrawConfig],
  components: {
    BvipIntroDialog
  },
  data () {
    return {
      passCardDialogVisible: false,
      termInfo: [], // 还款试算
      loanTerm: '',
      schdAmt: '', // 还款总额
      loanPrin: '', // 还款本金
      loanApplyNo: '',
      interestFee: 0,
      intRate: 0,
      maxIntRate: 0,
      maxInterestFee: 0,
      authenticationVisible: false,
      authenticationProtocol: '',
      timer: null,
      rateTipsVisible: false,
      loanProcess: '', // 大权益开关，如果为GVIP则为开，从试算带过来的
      checkGreatVIP: 'Y', // 选择大权益
      bvipVisible: false,
      loanProcessTitle: '',
      loanProcessSupplier: '', // WHD 万恒 d
      greatVIPCoupon: {},
      loanProcessMark: '',
      fundCode: '',
      cardText: '',
      guideProcessNo: '',
      auditPassTime: '',
      guideExpireTime: '',
      pending: false
    }
  },

  computed: {
    ...mapState('withdraw', {
      loanParameter: (state) => state.loanParameter,
      withdrawForm: (state) => state.withdrawForm
    }),

    ...mapState('user', ['userInfo']),
    isWHD () {
      return this.loanProcessSupplier === 'IRR36_XMPASS_WHD'
    }
  },
  watch: {
    // 监听大权益的勾选，弹出toast
    checkGreatVIP (value) {
      if (this.style === 'A') {
        this.$message('今日额度已抢完')
      }
      // this.getTermInfo()
    }
  },

  async created () {
    await this.guideApply()
    this.getBankcardList()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('withdraw', [ 'guideApplyX', 'guideLoanApplyX' ]),
    ...mapActions('bankcard', ['getBankcardListX']),
    actionWithdraw () {
      this.checkGreatVIP = 'Y'
      this.applyWithdraw()
    },
    // 新合规流程校验  mixins: withdrawConfig
    handlePreCheck () {
      if (this.style === 'B') {
        this.showStyleB()
        return
      }
      if (this.showDialogTips) {
        this.bBvipTipsVisible = true
        return
      }
      if (this.unCheckLead) {
        this.bvipActionSheetVisible = true
        return
      }
      this.applyWithdraw()
    },
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    finish () {
      this.backHome(true)
    },
 
    // 获取银行卡列表
    async getBankcardList () {
      const response = await this.getBankcardListX({
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        productCd: 'TMDP'
      })
      if (response.success && response.data.length > 0) {
        const _bank = response.data.find(item => item.bankCardNo === this.previousBankCardNo)
     
        if (this.previousBankCardNo && _bank) {
          this.cardText = `${_bank.bankName}(${this.previousBankCardNo.substr(-4, 4)})`
        } else {
          this.cardText = `暂未绑卡`
        }
      }
    },
 
    // 获取分期信息
    async guideApply () {
      const params = {
        guideBizProcess: 'IRR36A_GUIDE',
        checkGreatVIP: this.checkGreatVIP
      }
      let { success, data } = await this.guideApplyX(params)
      if (success) {
        this.termInfo = data.termInfo || []
        this.schdAmt = data.schdAmt
        this.loanPrin = data.loanPrin
        this.loanTerm = data.loanTerm
        this.interestFee = data.interestFee
        this.maxIntRate = data.maxIntRate
        this.maxInterestFee = data.maxInterestFee
        this.intRate = data.intRate
        this.loanProcess = data.loanProcess
        this.loanProcessTitle = data.loanProcessTitle
        this.loanProcessSupplier = data.loanProcessSupplier
        this.loanProcessMark = data.loanProcessMark
        this.greatVIPCoupon = data.greatVIPCoupon || {}
        this.previousBankCardNo = data.previousBankCardNo
        this.guideProcessNo = data.guideProcessNo
        this.auditPassTime = data.auditPassTime
        this.guideExpireTime = data.guideExpireTime - new Date().getTime()
        this.fundCode = data.previousFundCode
        this.complianceConfig = data.complianceConfig || {}
        this.checkGreatVIP = data.complianceConfig.defaultCheck
        this.mustCheck = data.mustCheck
      }
    },

    // 查看相关协议
    viewProtocol () {
      this.$router.push({
        path: '/withdraw/protocol',
        query: {
          fundCode: this.fundCode,
          busiType: 'LOAN',
          loanProcess: this.loanProcess
        }
      })
    },

    // 申请提现
    async applyWithdraw () {
      if (this.checkGreatVIP === 'N') {
        this.$message('今日额度已抢完，明日再来吧')
        return
      }
      // 全部完成 -> 去授信
      await this.riskReport(3)
      const params = {
        guideProcessNo: this.guideProcessNo,
        guideBizProcess: 'IRR36A_GUIDE',
        checkGreatVIP: this.checkGreatVIP
      }
      if (this.pending) return
      this.pending = true
      const response = await this.guideLoanApplyX(params)
      this.pending = false
      if (response.success) {
        this.loanApplyNo = response.data.loanApplyNo
        this.$router.replace(
          `/withdraw/result?loanApplyNo=${response.data.loanApplyNo}&noDialog=T`
        )
      } 
    }
 
  }
 
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

@keyframes shine {
  0% {
    background-color: #ffddd9;
  }

  20% {
    background-color: #ffffff;
  }

  40% {
    background-color: #ffddd9;
  }

  60% {
    background-color: #ffffff;
  }

  80% {
    background-color: #ffddd9;
  }

  100% {
    background-color: #ffffff;
  }
}

@keyframes newShine {
  0% {
    background-color: #ffffff;
  }

  16.7% {
    background-color: #ffddd9;
  }

  33.3% {
    background-color: #ffffff;
  }

  50% {
    background-color: #ffddd9;
  }

  66.7% {
    background-color: #ffffff;
  }

  83.3% {
    background-color: #ffddd9;
  }

  100% {
    background-color: #ffffff;
  }
}

.header-tips {
  width: 690px;
  height: 118px;
  background: #FEE9E8;
  border-radius: 10px;
  display: flex;
  padding: 10px;
  margin: 30px;
  &>img {
    width:54px;
    height:54px;
  }
  h3 {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF4633;
    line-height: 50px;
    padding-top: 5px;
  }
  p {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    padding-top: 5px;
  }
}
.apply-time {
  margin: 20px 30px;
  width: 690px;
  height: 80px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  .label {
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    img {
      width:54px;
      height:54px;
    }
  }
  span {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }

}
.info-bvip {
  background: url(./image/img_shou@2x.png) 514px 50px no-repeat #fff;
  background-size: 220px 206px;
  margin-top: 20px;
  padding: 38px 20px 30px 40px;
  .wh-title {
    margin-left: 45px;
    .title-info{
      padding-left: 3px;
      font-size: 30px;
      font-weight: bold;
      span {
        color: #FF4633;
      }
    }
    .title-info {
      margin: 12px 0 2px 0;
    }
  }
  .bvip-mark {
    display: flex;
    gap:10px;
    padding-left: 10px;
    .mark-item {
      background: #FFF2EB;
      padding: 0 10px;
      font-size: 22px;
      color: #9E5736;
      border-radius: 8px;
    }
    }

  &.shine {
    animation: newShine 3000ms infinite;
  }
 
  .bvip-title {
    font-size: 30px;
    color: #333333;
    line-height: 50px;
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-bottom:12px;

    .title-img {
      width: 32px;
      height: 32px;
      margin-right: 19px;
    }

    .title-tips {
      width: 24px;
      height: 24px;
      margin-left: 10px;
    }

    .title-info {
      margin-left: auto;

      span {
        color: #FF4633;
      }
    }
  }

  .bvip-info {
    font-size: 26px;
    line-height: 1em;
    color: #666666;
    padding-left: 50px;
  }
  
  .bvip-user-choss{
    font-size: 22px;
    box-sizing: border-box;
    height: 34px;
    line-height:34px;
    padding: 0px 5px;
    // border: 1px solid #FF4633;
    color: #aaa;
    border-radius: 3px;
  }

  .bvip-tips {
    font-size: 24px;
    color: #999999;
    line-height: 50px;
    padding-left: 50px;
  }
}

.pre-title {
 display: flex;
 padding: 15px 30px;
 margin-top: 10px;
 h3 {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
 }

}

.pre-info {
  background: #fff;
  display: flex;
  padding: 20px 30px;
  margin-bottom: 20px;
  justify-content: space-between;
  .item {
    display: flex;
    flex-direction: column;
    p{
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    span {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
}

.through {
  text-decoration: line-through;
  padding-right: 15px;
}

.withdraw-preview {
  padding-bottom: 285px;
  min-height: 100%;
  box-sizing: border-box;
  background-color: RGBA(250, 250, 250, 1);
  /deep/.info-line {
      height: 100px;
      line-height: 100px;
      position: relative;
      margin-bottom: 1px;
      font-size: 30px;
      padding: 0 5px;
      color: rgba(51, 51, 51, 1) !important;
      border-bottom: 0;

      &:last-child {
        animation: shine 2000ms step-end;
        // background-color: #FFDDD9 !important;
      }

      .custom-icon {
        display: block;
        width: 30px;
        height: 30px;
        /*background-image: url(../../assets/img/withdraw-preview/icon_explain@3x.png);*/
        background-size: 100%;
        float: right;
        position: relative;
        top: 35px;
        margin-left: 10px;
      }

      .weight {
        font-size: 34px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #20c7c7;
      }
    }
  .card-panel {
    margin-top: 20px;

 

    .info-other {
      width: 100%;
      background-color: #fff;
      margin-top: 21px;
      padding: 28px 30px;

      .other-title {
        color: #333333;
        font-size: 30px;
      }

      .other-money {
        color: #999999;
        font-size: 26px;
        margin-top: 15px;
      }

      .other-rate {
        color: #999999;
        font-size: 26px;
        margin-top: 10px;

        .other-img {
          width: 26px;
          height: 26px;
          vertical-align: -3px;
        }
      }
    }
  }

  .repayment-schedule {
    margin: 40px 30px 0;
    border-radius: 10px;

    &.b {
      background-color: #fff;

      .cell-title {
        padding: 33px 40px;

        .show-detail {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(142, 178, 216, 1);
          line-height: 50px;

          >img {
            width: 29px;
            height: 29px;
            margin-left: 8px;
            transition: all .3s;
          }
        }
      }
    }

    .cell-title {
      font-size: 32px;
      line-height: 50px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;

      em {
        font-size: 26px;
        font-style: normal;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: @fc3;
      }
    }

    .schedule-list {
      margin-top: 22px;
      padding-bottom: 20px;
      background-color: #ffffff;
      border-radius: 10px;

      table {
        width: 100%;
        border-spacing: 0px;

        .table-header {
          th {
            font-size: 27px;
            height: 50px;
            line-height: 50px;
            padding-top: 23px;
            padding-bottom: 7px;
            border-bottom: 1px solid @iuc;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
        }

        .table-row {
          td {
            height: 50px;
            line-height: 50px;
            font-size: 22px;
            padding-top: 10px;
            text-align: center;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          &+.table-row {
            td {
              padding-top: 2px;
            }
          }
        }
      }
    }
  }

  >.bottom {
    width: 750px;
    height: 265px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;


  .count-down-container {
    width: 670px;
    height: 116px;
    background: #FEE9E8;
    border-radius: 14px 14px 20px 0px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 20px;
    display: flex;
    padding: 15px;
    justify-content: space-between;
    .label {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    /deep/.van-count-down{
      .block {
        width: 44px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        background: #FF4633;
        border-radius: 4px;
        opacity: 0.6;
        display: inline-block;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF; 
      }
      .colon {
        font-size: 30px;
        font-weight: bold;
        color: #FF4633;
        opacity: .6;
      }
    }

    
  }

    .read-protocol {
      width: 100%;
      text-align: center;
      margin-top: 25px;

      span {
        font-family: 'PingFangSC-Regular';
        font-weight: 400;
        display: block;
        color: #666;
        font-size: 24px;
        line-height: 33px;

        em {
          font-style: normal;
          color: rgba(142, 178, 216, 1);
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }

    .withdraw-btn {
      width: 670px;
      height: 94px;
      border-radius: 47px;
      margin: 90px auto 0;
      position: relative;
    }
  }


  /deep/ .rate-tips-title {
    font-size: 42px;
    color: #333333;
    font-weight: bold;
    padding-left: 40px;
  }

  .rate-tips-dialog {
    padding: 40px 40px 60px;
    color: #666666;
    font-size: 28px;
  }
}
</style>
